export default "__VITE_ASSET__DqeN6QHh__"